const tabs = [
  {
    label: "Performance",
    value: "performance",
  },
  {
    label: "Session Recap",
    value: "session-recap",
  },
];

export function Tabs({ value, onChange, detailedReportFetching }) {
  return (
    <div className="flex gap-1">
      {tabs.map((tab) => {
        const button = (
          <button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            data-tutorial-performance-tab={tab.value === "performance" ? true : undefined}
            data-tutorial-session-recap-tab={tab.value === "session-recap" ? true : undefined}
            className={`report-tab-button relative text-base p-2 md:p-2.5 ${value === tab.value
                ? "text-primary selected-report-tab-button font-semibold"
                : "text-text-primary hover:text-text-primary/70 font-normal"
              } ${tab.value === "session-recap" && detailedReportFetching ? "opacity-50 cursor-wait" : ""}`}
            disabled={tab.value === "session-recap" && detailedReportFetching}
          >
            {tab.label}
          </button>
        );
        return tab.value === "session-recap" ? (
          <span key={tab.value} id="session-recap-tab" className="inline-block">
            {button}
          </span>
        ) : (
          button
        );
      })}
    </div>
  );
}
